import React from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import { useCopyToClipboard } from 'hooks';
import strings from 'strings';
import { FPIconButton } from 'UI/components/atoms';

const DESCRIPTION_GAP = 40;

export const SummarizeWithAIResults = ({ results }) => {
  const { copyToClipboard } = useCopyToClipboard();

  const handleCopyResults = () => {
    const text = results.map(({ title, description }) => `${title}\n${description}`).join('\n\n');
    copyToClipboard({ text });
  };

  return (
    <>
      <Box display="flex" justifyContent="space-between" alignItems="center" marginBottom={2}>
        <Typography variant="h6">
          {strings.inventoryProfiles.sections.tabs.referenceCheck.aiSummary.sectionTitle}
        </Typography>
        <FPIconButton
          onClick={handleCopyResults}
          showTooltipWhenDisabled
          icon={FileCopyIcon}
          iconMode="custom"
          family="mini"
          tooltipProps={{ title: strings.shared.ui.copy }}
        />
      </Box>

      <Box display="flex" flexDirection="column" gridGap={DESCRIPTION_GAP}>
        {results.map(({ title, description }) => (
          <div key={title}>
            <Typography variant="subtitle1" gutterBottom>
              {title}
            </Typography>
            <Typography variant="body2">{description}</Typography>
          </div>
        ))}
      </Box>
    </>
  );
};
